import React from 'react';
import { Separator } from '@fluentui/react';
import TranslateTag from '../../../../Utils/Local/TranslateTag';
import './FieldViewer.css'

const FieldViewer = (props) => {

    const fieldSizeCalc = (fieldLabel, fieldValue) => {

        var widthRequired = 0;
        if (fieldValue === null || fieldValue === undefined) {
            widthRequired = fieldLabel.length;
        } else {
            widthRequired = Math.max(fieldLabel.length, fieldValue.length);
        }

        switch (Math.trunc(widthRequired / 25)) {
            case 0:
                return '';
            case 1:
                return 'double-height';
            case 2:
                return 'triple-height';
            default:
                return 'xtra-long';
        }
    }

    const toggleTranslator = (fieldValue) => {
        switch (fieldValue) {
            case 'Yes':
                return TranslateTag("@GenYesA@", props.language);
            case 'No':
                return TranslateTag("@GenNo@", props.language);
            default:
                return fieldValue;
        }
    }

    const fieldsToDisplay = props.data.filter((f) => f.Value !== undefined && f.Value !== null && f.Value !== "");

    return (
        <React.Fragment>
            <div className='fieldviewer-fieldcontent'>
                {fieldsToDisplay.map((field) => (
                    <div key={field.Id} className={'fieldviewer-field ' + fieldSizeCalc(field.Label, field.Value)}>
                        <div  className='fieldviewer-itemname'>
                            {field.Label + ':'}
                        </div>
                        <div className={'fieldviewer-itemvalue' + (field.Highlight ? '-highlight ' : '')}>
                            {toggleTranslator(field.Value)}
                        </div>
                    </div>
                ))}
            </div>  
            <div className='fieldviewer-separator'>
                {(fieldsToDisplay.length > 0) ? (
                    <Separator></Separator>
                ) : (null)}
            </div>           
        </React.Fragment>
    );
};

export default FieldViewer;

